import { useContext } from 'react';
import SSRContext from './ssrContext';
export var useServerRequest = function useServerRequest() {
  var _ref = useContext(SSRContext) || {},
      req = _ref.req;

  return req;
};
export default SSRContext;